import { Card, Stack, Title, Code, Group, Button } from '@repletoryreach/sdk-ui';
import { notifySuccess } from '@repletoryreach/sdk-ui/notifications';
import { useT } from '../../../../i18n/I18nProvider';

export function ComponentsTab({ components }: { components: string }) {
  const t = useT();
  let pretty = components;
  try {
    pretty = JSON.stringify(JSON.parse(components), null, 2);
  } catch {
    // keep raw if non-JSON
  }
  return (
    <Card withBorder>
      <Stack gap="sm">
        <Group justify="space-between" align="baseline">
          <Title order={4}>{t('templates.drawer.components')}</Title>
          <Button
            size="xs"
            variant="outline"
            onClick={() => {
              void navigator.clipboard.writeText(pretty);
              notifySuccess(t('templates.view.components.copied'), t('toast.copied'));
            }}
          >
            Copy
          </Button>
        </Group>
        <Code block>{pretty}</Code>
      </Stack>
    </Card>
  );
}
